export default "__VITE_ASSET__b9a5c35e__"